import { defineComponent as _defineComponent } from 'vue'
import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, resolveDirective as _resolveDirective, withDirectives as _withDirectives, createBlock as _createBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = { class: "payment-single" }
const _hoisted_2 = { class: "payment-single__title" }
const _hoisted_3 = { class: "payment-single__method-name" }

import { computed, type PropType } from 'vue';


const __default__ = {
  name: 'PaymentSingle',
  customOptions: {},
};

export type PaymentSingleItem = {
  label: string;
  value: string;
  info?: {
    message: string;
  };
};

export default /*#__PURE__*/_defineComponent({
  ...__default__,
  props: {
  method: { type: Object as PropType<PaymentSingleItem>, required: true },
  network: { type: Object as PropType<PaymentSingleItem | undefined>, required: false },
  networkFee: { type: Object as PropType<PaymentSingleItem | undefined>, required: false },
},
  setup(__props) {

const props = __props;

const itemsToShow = computed(() => {
  const a = [props.method];

  if (props.network) {
    a.push(props.network);
  }

  if (props.networkFee) {
    a.push(props.networkFee);
  }

  return a;
});

const getTooltip = (d: { message: string }) => ({
  content: d.message,
  theme: 'tooltip-coin-network',
  placement: 'right',
});

return (_ctx: any,_cache: any) => {
  const _component_ot_icon = _resolveComponent("ot-icon")!
  const _directive_tooltip = _resolveDirective("tooltip")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(itemsToShow.value, (item) => {
      return (_openBlock(), _createElementBlock("div", {
        key: item.label,
        class: "payment-single__label"
      }, [
        _createElementVNode("div", _hoisted_2, [
          _createElementVNode("span", null, _toDisplayString(item.label), 1),
          (item.info)
            ? _withDirectives((_openBlock(), _createBlock(_component_ot_icon, {
                key: 0,
                class: "payment-single__info-icon",
                name: "info-circle"
              }, null, 512)), [
                [_directive_tooltip, getTooltip(item.info)]
              ])
            : _createCommentVNode("", true)
        ]),
        _createElementVNode("div", _hoisted_3, _toDisplayString(item.value), 1)
      ]))
    }), 128))
  ]))
}
}

})